import React, { Component } from 'react';
import { Table, Tag, Space, PageHeader, Modal, Button, Input, Row, Col, Select, Tooltip, Popconfirm, Pagination, Skeleton } from 'antd';
import { Container } from '../../components/layout/style';
import {CameraOutlined, CheckCircleOutlined, ClearOutlined, EditOutlined, EyeFilled, PlusSquareOutlined, StopOutlined} from '@ant-design/icons'
import AddProduct from './addProduct';
import { connect } from 'react-redux';
import {getAllProducts, updateProductAuth} from '../../actions/product';

import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import EditProduct from './editProduct';
import UpdateImage from './updateImage';
import './style.css'
import history from '../../history';
const { Option } = Select;
class ProductList extends React.Component {
  state = {
    product_id: null,
    isModalVisible: false,
    isEditModalVisible: false,
    isImageModalVisible: false,
    searchText: '',
    searchedColumn: '',
    data: [],
    name: '',
    product_id: '',
    active: '',
    page: 1,
    total: null,

  }
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const {name, product_id, active,page} = this.state
    const res = await this.props.getAllProducts(page,name,product_id,active)
    this.setState({data: res.product,total:res.count})
  }
  
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  createData = (product_id,name,thumbnail,active, created_at,action) => {
    return {product_id, name,thumbnail,active, created_at,action};
  };
  makeLocalTime = (date) => {
    let mainDate = date.split('T')[0];
    let hours = date.split('T')[1].split(':')[0];
    let minutes = date.split('T')[1].split(':')[1];
    var am = true;
    if (hours > 12) {
        am = false;
        hours -= 12
    } else if (hours == 12) {
        am = false;
    } else if (hours == 0) {
        hours = 12
    }
    return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
  }
  
  handleApiSearch = async () => {
    const {name, product_id, active,page} = this.state
    const res = await this.props.getAllProducts(page,name,product_id,active)
    this.setState({data: res.product,total:res.count})
  }
  resetSearch = async () => {
    const res = await this.props.getAllProducts(1,'','','')
    this.setState({data: res.product, name: '',active: '',product_id: '', name: ''})
  }
  handleRefresh = async (page) => {
    if(page){
      this.setState({page:page})
    }
    const res = await this.props.getAllProducts(page ? page : 1,'','','')
    this.setState({data: res.product,total:res.count})
  }

  handleStatus = async (product,status) => {
    const res = await this.props.updateProductAuth(product,status)
    if(res === 201){
      this.handleRefresh()
    }
  }
  handleImage = async (product) => {
    const res = await this.props.updateProductAuth(product)
    if(res === 201){
      this.handleRefresh()
    }
  }
  render() { 
    
    const columns = [
      {
        title: 'Product ID',
        dataIndex: 'product_id',
        key: 'product_id',
        ...this.getColumnSearchProps('product_id'),
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Status',
        dataIndex: 'active',
        key: 'active',
      },
      {
        title: 'Thumbnail',
        dataIndex: 'thumbnail',
        key: 'thumbnail',
      },
      {
        title: 'Created at',
        key: 'created_at',
        dataIndex: 'created_at',
        
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
      
      },
    ];
    
    const {data,total} = this.state;
    
    const rows = [
      data
        ? data.map((data) => this.createData(
          data.product_id, 
          data.name, 
          <>
          {data.thumbnail ?               
          <>
          
          <img className='thumb' src={`${process.env.REACT_APP_API_BASE_URL}/files/${data.thumbnail}`} width="50px" alt="" /> &nbsp;&nbsp;
            <Button size="small" type="primary" icon={<EditOutlined  />} onClick={()=>this.setState({product_id: data.product_id, isImageModalVisible :true})}>Update</Button>
          </>
          :
          <>
          <img className='thumb' src="./demo.jpg" width="50px" alt="no image found" /> &nbsp;&nbsp;
           <Button size="small" type="primary" icon={<CameraOutlined />} onClick={()=>this.setState({product_id: data.product_id, isImageModalVisible :true})}>Add</Button>
          </>
           
           }
          </>, 
          <>
          {data.active === 'active' ?
            <> 
              <Tag color="#87d068">Active</Tag> 
              <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.handleStatus(data.product_id, 'inactive')}><Button size="small" type="danger" icon={<StopOutlined  />}>Disable</Button></Popconfirm>
            </>: 
            <>
              <Tag color="#f50">Inactive</Tag>
              <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.handleStatus(data.product_id, 'active')}><Button size="small" type="secondary" icon={<CheckCircleOutlined  />}>Activate</Button></Popconfirm>
            </>
          }
          
          </>,
          this.makeLocalTime(data.created_at), 
          
         
          <>
          
           <Button size="small" type="primary" icon={<EditOutlined  />} onClick={()=> this.setState({product_id: data.product_id, isEditModalVisible: true})}>Edit</Button> &nbsp;
           <Button size="small" type="primary" icon={<EyeFilled  />} onClick={()=> history.push(`/product-details?id=${data.product_id}`)}>View</Button> &nbsp;
          {/*<Popconfirm title="Are you sure？" okText="Yes" cancelText="No"><Button size="small" type="danger" icon={<DeleteOutlined  />}>Delete</Button></Popconfirm>
          <br />
          <br />
          <Button size="small" type="primary" icon={<SettingOutlined />} >Change Password</Button> &nbsp; */}
          
          </>
          ))
        : "",
    ];
    return (
      
      <Container style={{minHeight: '100vh'}}>
        <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="Products"
            subTitle="List of all products"
            extra={[
                <Button key="1" type="primary" icon={<PlusSquareOutlined />} onClick = { ()=>this.setState({isModalVisible :true})}>
                    Add Product
                </Button>,
            ]}
        >
        </PageHeader>
        <br />
            <Row gutter={10}>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Input placeholder="Product Name" allowClear style={{width:'99%', margin: '10px 0px'}} onChange={(e)=>this.setState({name:e.target.value})} />
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Input placeholder="Product Id" allowClear style={{width:'99%', margin: '10px 0px'}} onChange={(e)=>this.setState({product_id:e.target.value})} />
               
                </Col>
                <Col xs={12} sm={12} md={8} lg={8} xl={7}>
                    <Select
                        showSearch
                        style={{ width: "99%", margin: '10px 0px' }}
                        placeholder="Select a status"
                        name="status"
                        optionFilterProp="children"
                        onChange={(e)=>this.setState({active:e})}
                        filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option value="">None</Option>
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>
                 </Col>
                <br />
                
                <Col xs={12} sm={12} md={6} lg={6} xl={3}   style={{ margin: '10px 0px'}}>
                   &nbsp;&nbsp;&nbsp;&nbsp;
                    <Tooltip title="Search" onClick={this.handleApiSearch}>
                        <Button type="primary" shape="circle" icon={<SearchOutlined />} />
                    </Tooltip>
                   &nbsp;&nbsp;&nbsp;&nbsp;
                    <Tooltip title="Reset" onClick={this.resetSearch}>
                        <Button type="primary" shape="circle" icon={<ClearOutlined />} />
                    </Tooltip>
                </Col>
            </Row>
            <br />
            <br />
            {data ?
              <Table columns={columns}  scroll={{ x: 10 }} dataSource={rows[0]} pagination={false} />
              : 
              <Skeleton paragraph={{ rows: 5 }}  />
            }
            
      <br />
      <Pagination  defaultCurrent={1} total={total} pageSize={20} style={{textAlign: 'right', paddingRight: '100px'}} onChange={(page) => this.handleRefresh(page)} />
      <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Add A New Product" visible={this.state.isModalVisible} onCancel={()=>this.setState({isModalVisible :false})}>
          <AddProduct close={() => this.setState({isModalVisible :false})} fnc={this.handleRefresh} />
      </Modal>
      <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Edit Product" visible={this.state.isEditModalVisible} onCancel={()=>this.setState({isEditModalVisible :false})}>
          <EditProduct close={() => this.setState({isEditModalVisible :false})} id={this.state.product_id}  fnc={this.handleRefresh} />
      </Modal>
      <Modal okButtonProps={{ style: { display: 'none' } }} okText="Close" width="70%" title="Update thumbnail" visible={this.state.isImageModalVisible} onCancel={()=>this.setState({isImageModalVisible :false})}>
          <UpdateImage close={() => this.setState({isImageModalVisible :false})} type="product-thumbnail" id={this.state.product_id}  fnc={this.handleRefresh} />
      </Modal>
  </Container>
    );
  }
}
 
export default connect(null,{getAllProducts, updateProductAuth})(ProductList);